import { type FC, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { DeviceSettings } from 'entities/DeviceSettings'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallModalStore } from 'widgets/CallModal'
import { CallSearchContacts } from 'widgets/CallSearchContacts'
import { SendFrom } from 'widgets/SendFrom'
import { CallModalActiveCard } from './CallModalActiveCard/CallModalActiveCard'
import styles from './styles.module.scss'

type ICallModalActionsProps = {
  callModalStore: CallModalStore
}

export const CallModalContent: FC<ICallModalActionsProps> = observer(({ callModalStore }) => {
  const { sendFromStore } = callModalStore
  const { callStore } = useEntitiesContext()

  useEffect(() => void callModalStore.init(), [])

  return (
    <div className={styles.wrap}>
      <div className={styles.section}>
        <div className={styles.box}>
          <SendFrom triggerVariant={'button'} store={sendFromStore} />
        </div>
        <div className={styles.box}>
          <DeviceSettings
            deviceSettingsStore={callStore.deviceSettingsStore}
            dropdownProps={{
              placement: 'bottom-end',
              width: 246,
              margin: 4,
              disabled: callStore.loading,
              ariaLabel: 'deviceSettings',
            }}
            variantDropdownBtn={'icon'}
            testOutputDevice={callStore.testOutputDevice}
          />
        </div>
      </div>

      <div className={styles.section}>
        {callModalStore.contact && (
          <CallModalActiveCard
            item={callModalStore.contact}
            onDelete={callModalStore.handleClearValue}
          />
        )}

        {!callModalStore.contact && (
          <CallSearchContacts
            onChange={callModalStore.handleChangeValue}
            error={callModalStore.numberError}
          />
        )}
      </div>
    </div>
  )
})
